import { Component } from '@angular/core';
import { SelectTemplate } from 'src/app/@amiga-pyme/select/templates/select.template';
import {
  IRegulatedProduct,
  REGULATED_PRODUCT_TTL_ES
} from '../regulated-product.interface';
import { RegulatedProductService } from '../regulated-products.service';
import { getTagColor } from '../../../../../helpers/tag-color.helpers';

@Component({
  selector: 'pg-regulated-product-select',
  template: `
    <ami-select
      [settings]="table.settings"
      [data]="table.data"
      (selectedRowsEvent)="onReciveSelectedRows($event)"
    ></ami-select>
  `
})
export class RegulatedProductSelectComponent extends SelectTemplate {
  constructor(private regulatedProductService: RegulatedProductService) {
    super(REGULATED_PRODUCT_TTL_ES, regulatedProductService);
  }

  ngOnInit() {
    this.table.settings = {
      title: REGULATED_PRODUCT_TTL_ES,
      columns: [
        { header: 'Código', field: 'code' },
        { header: 'Código de barras', field: 'barCode' },
        { header: 'Nombre', field: 'name' },
        { header: 'Concentración', field: 'concentration' },
        { header: 'form', field: 'form' },
        { header: 'formSimp', field: 'formSimp' },
        { header: 'Presentación', field: 'presentation' },
        { header: 'Laboratorio', field: 'laboratory' },
        { header: 'Fracción', field: 'fractions' },
        { header: 'Condición', field: 'condition' }
      ]
    };
    this.initSubscriptions$();
  }

  initSubscriptions$() {
    this.suscriptionBase$ = this.regulatedProductService
      .getData$()
      .subscribe((data: IRegulatedProduct[]) => {
        data = data.map((item) => {
          item.tagStatusColor = getTagColor(item.conditionCode);
          return item;
        });
        this.table.data = data;
      });
  }

  ngOnDestroy() {
    this.unsubscribeBase();
  }
}
